import {insert, validateStatus} from "./helpers";
import axios from "axios/index";
import {SERVICE_URL} from "./constants";

const resource = 'users';

export function insertUserAPI(user) {
  return insert(resource, user, user.id);
}

export function loginUserAPI(payload) {
  
  const { username, password } = payload;
  
  const body = JSON.stringify({ username, password });
  const headers = {'Content-Type': 'application/json'};
  
  const typeName = resource + '/login';
  
  return axios.post(`${SERVICE_URL}/${typeName}`,
    body,
    {headers})
    .then(validateStatus(200))
    .then(response => response.data)
    .then(responseData => {
      console.info(`[api.helpers.authenticate] response`, responseData);
      return responseData;
    });
}


// WEBPACK FOOTER //
// ./src/api/userAPI.js